import { fetchEndpoint } from '../server/network';

// 专题列表接口
export const topicList = (display_area,page,per_page) => fetchEndpoint('/v2/ecapi.topic.list', 'POST', {display_area,page,per_page})
  
// 专题商品接口
export const topicProductList = (topic_id,page,per_page,by_category) =>{
  return fetchEndpoint('/v2/ecapi.topic.product.list', 'POST',{topic_id,page,per_page,by_category})
} 


// 首页定位
export const homeAddress = (lng, lat, type) =>fetchEndpoint('/v2/ecapi.auth.position', 'POST', { lng, lat, type})


// 首页附近店铺地址
export const authPosition = (lng, lat, type=1) =>fetchEndpoint('/v2/ecapi.auth.position', 'POST', { lng, lat, type})


// 首页分类
export const navList = () =>fetchEndpoint('/v2/ecapi.nav.list', 'POST', {})

// 首页模块接口
export const modulelLst = () =>fetchEndpoint('/v2/ecapi.module.list', 'POST', {})

// 扫描商品条码获取商品id接口
export const bybarcode = (barcode) => fetchEndpoint('/v2/ecapi.bybarcode.get', 'POST', { barcode })





// 扫描商品条码获取商品id接口
export const cashGiftList = (status , per_page , page ,  after =0) => 
      fetchEndpoint('/v2/ecapi.cashgift.list', 'POST', 
                    { status,
                      per_page,
                      page,
                      after
                     })




// WEBPACK FOOTER //
// ./src/api/home.js